
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 512 512"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M416.742 506H290.884v-34.933h-69.769V506H95.258v-34.933h41.724V40.931h52.328V6h133.382v34.931h52.326v430.136h41.725V506zM274.913 226.192h-42.004v42.06h42.004v-42.06zm0 84.121h-42.004v42.061h42.004v-42.061zm0 84.121h-42.004v42.06h42.004v-42.06zm63.486-168.242h-42.003v42.06h42.003v-42.06zm0 84.121h-42.003v42.061h42.003v-42.061zm0 84.121h-42.003v42.06h42.003v-42.06zM211.873 226.192H169.87v42.06h42.003v-42.06zm0 84.121H169.87v42.061h42.003v-42.061zm0 84.121H169.87v42.06h42.003v-42.06zm63.04-333.311h-42.004v42.06h42.004v-42.06zm0 84.121h-42.004v42.061h42.004v-42.061zm63.486-84.121h-42.003v42.06h42.003v-42.06zm0 84.121h-42.003v42.061h42.003v-42.061zM211.873 61.123H169.87v42.06h42.003v-42.06zm0 84.121H169.87v42.061h42.003v-42.061z"}})])
          )
        }
      }
    